/* eslint-disable no-nested-ternary */
import { AccountCircle, VerifiedUser } from '@mui/icons-material';
import { Avatar, Box, Menu, MenuItem, Typography } from '@mui/material';
import { FC, SyntheticEvent, useEffect, useRef, useState } from 'react';
import { TUser } from 'redux/reducers/user/types';
import { UserAvatar } from 'ui/UserAvatar';
import { stringAvatar, stringToColor } from 'utils/stringAvatar';
import { useSelector } from 'react-redux';
import { getUsersList } from '../../redux/reducers/user/selectors';

export type TUserAvatarMenuProps = {
	user: TUser | null;
	size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
	onClick?: (index: number) => void;
	onClickUser?: (user: TUser | null) => void;
	users?: TUser[];
	delateButton?: boolean;
	onDeleteUser?: (user: TUser) => void;
};
export const UserAvatarMenu: FC<TUserAvatarMenuProps> = ({
	user,
	users,
	onClick,
	onClickUser,
	size = 'sm',
	delateButton = false,
	onDeleteUser,
}) => {
	const loadedUsers = useSelector(getUsersList);
	const usersList = users ?? loadedUsers;

	const refUserFilter = useRef<HTMLButtonElement>(null);
	const [openUserMenu, setOpenUserMenu] = useState(false);
	const handleClickUserMenu = (e: SyntheticEvent) => {
		if (usersList?.length === 0) return;
		setOpenUserMenu(true);
		e.stopPropagation();
	};
	const handleCloseUserMenu = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpenUserMenu(false);
	};

	const handleSelectUser = (index: number, e: SyntheticEvent) => {
		setOpenUserMenu(false);
		onClick?.(index);
		onClickUser?.(usersList?.[index] ?? null);
		console.log('handleSelectUser', index);
		e.stopPropagation();
	};

	useEffect(() => {
		if (user?.id === 'new-user') {
			setOpenUserMenu(true);
		}
	}, [user]);

	return (
		<Box
			ref={refUserFilter}
			style={{ position: 'relative', right: '0', top: '0', width: 'auto', height: '100%' }}
		>
			<UserAvatar user={user} size={size} onClick={handleClickUserMenu} tooltip={false} />
			<Menu
				anchorEl={refUserFilter.current}
				open={openUserMenu}
				onClose={handleCloseUserMenu}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
				sx={{
					'& .MuiMenu-paper': {
						borderRadius: '12px',
					},
				}}
			>
				{usersList?.map?.((item, index) => {
					return (
						<MenuItem
							key={item.email}
							color="primary"
							sx={{ color: 'primary.main', fontWeight: 'bold', p: '4px 5px' }}
							onClick={e => {
								handleSelectUser(index, e);
							}}
						>
							<UserAvatar user={item} size="sm" onClick={() => null} tooltip={false} />
						</MenuItem>
					);
				}) ?? null}
				{delateButton && (
					<MenuItem
						key="delete-user"
						color="primary"
						sx={{ color: 'primary.main', fontWeight: 'bold' }}
						onClick={() => {
							onDeleteUser?.(user ?? (null as unknown as TUser));
						}}
					>
						Delete User
					</MenuItem>
				)}
			</Menu>
		</Box>
	);
};
